import { SuiClient } from '@mysten/sui/client';
const NETWORKS = {
    mainnet: { url: 'https://fullnode.mainnet.sui.io/' },
    testnet: { url: 'https://fullnode.testnet.sui.io/' },
    devnet: { url: 'https://fullnode.devnet.sui.io/' },
};
export function getSuiClient(network) {
    const selectedNetwork = network || 'mainnet';
    const networkConfig = NETWORKS[selectedNetwork];
    if (!networkConfig) {
        throw new Error(`Unsupported network: ${selectedNetwork}`);
    }
    return new SuiClient({
        url: networkConfig.url,
    });
}
